import { handleLocalStorage } from "@/utils/handleLocalStorage.js";
import md5Encrypt from "@/components/md5Encrypt";
import http from "@/components/new/common/httpRequest/http";
import router from "@/router";
import { resetRouter } from "@/router";

const state = () => ({
  userInfo: handleLocalStorage.getSomeItem("userInfo") || {} // 用户信息
});

const getters = {};

const actions = {
  // 登录
  login({ commit, state, dispatch }, { userAccount, userPassword, type }) {
    return new Promise((resolve, reject) => {
      http(
        "/api/login",
        {
          userAccount,
          userPassword: md5Encrypt(userPassword)
        },
        "POST"
      )
        .then(res => {
          if (res.data.status === 200) {
            let result = res.data.data;
            // 存储token
            handleLocalStorage.setTokenItem(result.token);
            handleLocalStorage.setSomeItem("refreshToken", result.refreshToken);
            dispatch("getInfo", result.userId);
            // 跳转到工作台
            if (type == 1) {
              router.replace({ path: "/" });
            } else {
              router.replace({ path: "/home" });
            }

            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // 获取用户信息
  getInfo({ commit }, id) {
    http(`/api/user/user/id/${id}`).then(res => {
      let result = res.data.data;
      let userInfo = {
        ...result,
        userId: result.userPkId,
        authority: result.roleCode
      };
      handleLocalStorage.setSomeItem("userInfo", userInfo);
      commit("SET_USER_INFO", userInfo);
    });
  },

  updatedInfo({ commit }, data) {
    commit("SET_USER_INFO", data);
  },
  // 注册
  register({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      http(
        "/api/register",
        {
          ...data,
          userPassword: md5Encrypt(data.userPassword)
        },
        "POST"
      ).then(res => {
        resolve();
      });
    });
  },
  // 重置密码
  resetPwd({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      http(
        "/api/website/editPass",
        {
          ...data,
          password: md5Encrypt(data.password)
        },
        "POST"
      ).then(res => {
        resolve();
      });
    });
  },
  // 退出登录
  logout({ commit }) {
    resetRouter(); // 重置路由表
    handleLocalStorage.removeTokenItem();
    handleLocalStorage.removeSomeItem("userInfo");
    handleLocalStorage.removeSomeItem("refreshToken");
    handleLocalStorage.removeSomeItem("dcAccountUuid");
    commit("SET_USER_INFO", {});
    commit("permission/SET_PERMISSION_LIST", [], { root: true });
  }
};

// mutations
const mutations = {
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
